import {UserActionType} from '../constants/userActionType';
import {GifActions} from "../constants/gifActions";


const INITIAL_STATE = {
    authenticated: false,
    currentUser: null,
    loading: true,
    errorMessage: ''};


export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case UserActionType.LOGIN :
            return {
                ...state,
                authenticated: action.payload.authenticated,
                currentUser: action.payload.user,
                loading: false ,
                errorMessage: ''
            };
            case UserActionType.LOGOUT :
            return {
                ...state,
                authenticated: action.payload.authenticated,
                currentUser: action.payload.user,
                loading: false ,
                errorMessage: ''
            };
        case UserActionType.AUTH_ERROR:
            console.log(action.payload)
            return { ...state, errorMessage: action.payload };
        case GifActions.ADD_FAVORITE :
            return {
                ...state,
                currentUser: action.payload.user
            };
        case GifActions.DELETE_FAVORITE :
            return {
                ...state,
                currentUser: action.payload.user
            };
            case UserActionType.UPDATE :
            return {
                ...state,
                currentUser: {...state.currentUser, ...action.payload.user}
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/user.ts